import { post } from "../../service/api";

const AdminAuth = async (payload) => {
  try {
    const response = await post(`/admin/auth`, payload);
    return response;
  } catch (error) {
    console.error("Error admin auth:", error);
    throw error;
  }
};

export default AdminAuth;
